import { render, staticRenderFns } from "./ExemptionUpdate.vue?vue&type=template&id=33920aa1&scoped=true&"
import script from "./ExemptionUpdate.vue?vue&type=script&lang=js&"
export * from "./ExemptionUpdate.vue?vue&type=script&lang=js&"
import style0 from "./ExemptionUpdate.vue?vue&type=style&index=0&id=33920aa1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33920aa1",
  null
  
)

export default component.exports